import { MenuAction } from '@shared/interfaces/header/menu-action';
import { ContactRound } from 'lucide-angular';

export const MeteringPointCoreDataActionMenu: MenuAction[] = [
  {
    id: 'suggest',
    title: 'Foreslå kontaktinformation',
    icon: ContactRound
  }
];
